import React from 'react';
import { CiriumWrapper } from '../components/cirium/CiriumWrapper';
import { CiriumErrorPage } from '../components/errors/CiriumErrorPage';

const TravelerErrorContainer: React.FC = () => {
  return (
    <CiriumWrapper>
      <CiriumErrorPage />
    </CiriumWrapper>
  );
};

export default TravelerErrorContainer;